export const START_DATE = "startDate";
export const END_DATE = "endDate";
export const ASSIGNED_STATUS = "assignedStatus";
export const QA_ANALYST_ID = "qaAnalystId";
export const VALIDATION_TYPE_IDS = "validationTypeIds";
export const STATUS = "status";
export const IS_VALID = "isValid";
export const HAS_CUSTOMER_INCIDENT = "hasCustomerIncident";
export const BRANCH_IDS = "branchIds";
export const REP_IDS = "repIds";
export const AGENT_ID = "repLogin";
export const ENROLLMENT_ID = "enrollmentId";
export const SALE_ID = "saleId";
export const ENTITY_VALUE = "entityValue";
